module.exports = __webpack_public_path__ + "img/logo-place-energie.53b47307.png";